/**
 * @file 接口配置文件
 * @author quda
 */

let baseUrl = '';
let paiServer = '';
let quanjingServer = '';
let svServer = '';

const salt = '@5%D*3VFP9pAnWFX';

switch (process.env.NODE_ENV) {
    // 开发机环境
    case 'development':
        baseUrl = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094';
        paiServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094';
        // baseUrl = 'http://yq01-aip-tianzhi352a1e55.yq01.baidu.com:8021';
        // baseUrl = 'http://nj02-map-navi-routing-engine20-24.nj02.baidu.com:8986';

        // paiServer = 'http://nj02-map-navi-routing-engine20-24.nj02.baidu.com:8986';
        // paiServer = 'http://gzns-streetview-dataproc01.gzns.baidu.com:8088';
        // quanjingServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8112';
        // svServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8087';
        // baseUrl = 'https://content.map.baidu.com/mapcjhactivity';
        // paiServer = 'https://pai.baidu.com';
        quanjingServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8086';
        // quanjingServer = 'https://quanjing.baidu.com/xgc';
        svServer = 'https://sv.map.baidu.com/api';
        break;

        // QA环境
    case 'test':
        baseUrl = 'https://content.map.baidu.com/mapcjhactivity';
        paiServer = 'https://pai.baidu.com';
        break;

        // 线上环境
    case 'production':
    default:
        // paiServer = 'http://gzns-streetview-dataproc01.gzns.baidu.com:8088';
        // baseUrl = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094';
        // paiServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094';
        // // quanjingServer = 'http://xiaoxianyan.bcc-gzhxy.baidu.com:8080';
        // paiServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8888';
        // quanjingServer = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8086';
        baseUrl = 'https://content.map.baidu.com/mapcjhactivity';
        paiServer = 'https://pai.baidu.com';
        quanjingServer = 'https://quanjing.baidu.com/xgc';
        svServer = 'https://sv.map.baidu.com/api';
        break;
}

/**
 * 获取红包
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/7BO_MjiN-9J9fl
 */
export const getRedPacket = {
    salt: '@5%D*3VFP9pcdckdwnWFX',
    isMock: false,
    needSign: true,
    // signParams: ['source', 'pid', 'pitch', 'heading', 'cuid', 'os', 'sv'],
    signParams: ['source', 'pid', 'pitch', 'heading', 'cuid', 'qt'],
    url: `${baseUrl}/activity/spring2023/redenvelope`
};

/**
 * 拆红包
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/d1d80681855743
 */
export const openRedPacket = {
    salt,
    isMock: false,
    needSign: true,
    signParams: ['to', 'vw', 'zid', 'cuid', 'os', 'sv'],
    url: `${baseUrl}/activity/panoworldcup/lottery`
};

// 助力红包
export const assistRedPacket = {
    salt: '@5%D*3VFP9pcdckdwnWFX',
    isMock: false,
    needSign: true,
    signParams: ['cuid', 'to_user', 'qt'],
    url: `${baseUrl}/activity/spring2023/assist`
};

/**
 * 红包配置信息
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/fd689915c61043
 */
export const getConfig = {
    salt,
    isMock: false,
    needSign: true,
    signParams: ['cuid', 'os', 'sv'],
    url: `${baseUrl}/activity/spring2023/activityconf`
};

export const getExtralConfig = {
    salt: 'xYhGb&l&*t8e',
    isMock: false,
    needSign: true,
    signKey: 'pano_sign',
    signParams: ['qt', 'cuid', 'from'],
    url: `${paiServer}/ugc/feed/getfeedextral`
};

/**
 * 全景流频道tab配置接口
 */
export const getTab = {
    salt: 'xYhGb&l&*t8e',
    isMock: false,
    needSign: true,
    signKey: 'pano_sign',
    signParams: ['qt', 'group_name', 'from', 'loc', 'city_id', 'direct_channel', 'panorama_recommend'],
    url: `${paiServer}/ugc/feed/channellist`
};

/**
 * 通过pid获取用户信息（头像、name等）
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/hfXUf_sITOuRpy
 */
export const getPanoAuthor = {
    salt: 'htww1CsfdCNG1OzG',
    isMock: false,
    needSign: true,
    signParams: ['pid', 'provider', 'userid', 'source'],
    url: `${quanjingServer}/service/data/author`
};

// 主页接口
export const getDataList = {
    salt: 'xYhGb&l&*t8e',
    isMock: false,
    needSign: true,
    signKey: 'pano_sign',
    signParams: ['qt', 'userid', 'from', 'pn', 'rn'],
    url: `${paiServer}/ugc/feed/userfeed`
};

/**
 * 拍摄校验接口
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/5XV1IX8SkkWMaY
 */
export const startphoto = {
    isMock: 0,
    url: 'https://quanjing.baidu.com/xgc/ugc/startphoto',
    needSign: true,
    salt: 'htww1CsfdCNG1OzG',
    signParams: ['qt', 'sv', 'loc', 'attach_loc', 'os', 'mb', 'source', 'mode', 'task_type',
        'oid', 'zid', 'city_id', 'sub_source', 'cuid']
};

/**
 * 获取新消息数量提示
 * @see => https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/bC_f_7topr/f1hu25V7LA/uiwl3gihw1cJLS#anchor-19bb79e0-a6bd-11ed-9fcc-ff7eb404f30d
 */
export const getMsgNotif = {
    isMock: 0,
    url: `${paiServer}/ugc/mark/getmsgnotif`,
    needSign: false
};

/**
 * 新消息提醒
 */
export const msgRemind = {
    isMock: 0,
    url: `${svServer}/user/msgremind`,
    needSign: false
};

/**
 * 获取拍摄信息接口
 */
export const getPublishInfo = {
    isMock: 0,
    // FIXME
    url: `${quanjingServer}/ugc/work/publishinfo`,
    needSign: true,
    salt: 'htww1CsfdCNG1OzG',
    signKey: 'sign',
    signParams: ['qt', 'work_id', 'cuid', 'zid', 'sv', 'scene_type']
};

// export const BosToken = {
//     isMock: 0,
//     url: 'https://mbc.baidu.com/bdpmng/sts',
//     // url: 'http://xiaoxianyan.bcc-gzhxy.baidu.com:8080/ugc/shoot/init?sinan=a%3DWlLCrLNpz%2FX1V0qvTz9g%2F%3DO&gid=&c3_aid=A00-MHDPOMKJYGBKOMSQYCSTF24JFCXNFDOO-VJUJXJLD&channel=1006816w&lct_id=189&screen=%28720%2C1440%29&ai_mode=3&resid=01&patchver=&op_activity=&abtest=44948%2C103395%2C103369%2C103357%2C103355%2C103350%2C103347%2C103327%2C103302%2C103300%2C103265%2C103233%2C103202%2C103198%2C103193%2C103165%2C45172%2C103112%2C103337%2C103087%2C103180%2C100559%2C102412%2C102953%2C100149%2C101096%2C102951%2C102930%2C102772%2C102693%2C101230%2C103049%2C102708%2C102863%2C101283%2C102705%2C103279%2C103171%2C102241%2C103138%2C101137%2C102467%2C102414%2C101296%2C100782%2C101184%2C102332%2C102121%2C102941%2C100822%2C103196%2C102907%2C101868%2C103317%2C102170%2C101480%2C103292%2C102370%2C101225%2C103009%2C100558%2C103058%2C102925%2C101186%2C102239%2C103386%2C102714%2C101183%2C103108&support_abi=arm64-v8a&zid=owHz3adCHxM4EHxcIlO1-rQMul2ITvezG_rDlCPYBi2ZzcYj8Eny3LJpJyq2xW-UNH3fKYaPCabwZnVZ9oS0G7g&cpu_abi=arm64-v8a&mb=DUB-TL00&oem=baidu&bduid=ricy85aGl_7mr2tlO&dpi=%28320%2C320%29&net=0&ctm=1678174421.614000&sinan_ext=aBkIzUTIW0FnO&ver=1&ndid=&sv=17.3.0&cuid=CF59761D841247A853134573F0EE2BB2%7CO&os=Android27&cpu=INVALID&first_install=0&phonebrand=HUAWEI&co=460%3A00&glr=&hp_mode=5-1&glv=&mlogid=8653345&sesid=1678174035&scene_code=1200200000110000&sub_ai_mode=0&type=community',
//     needSign: false
// };

export const BosToken = {
    isMock: 0,
    url: 'https://quanjing.baidu.com/xgc/ugc/shoot/init',
    // url: 'http://gzhl-streetview-dataproc.gzhl.baidu.com:8136/ugc/shoot/init',
    needSign: true,
    salt: 'htww1CsfdCNG1OzG',
    signKey: 'sign',
    signParams: ['type']
};